import { FeatureFlag } from '../../proto/tumelo/stewardshipbff/v1/feature_flag'

export const sampleFeatureFlag = (override?: Partial<FeatureFlag>): FeatureFlag =>
  FeatureFlag.fromPartial({
    key: 'test_ff',
    state: false,
    ...override,
  })
